import { AImageProps } from '../../atoms/AImage/AImage.types';
import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import { MLogoContainerProps } from '../MLogoContainer/MLogoContainer.types';
import { MTagProps } from '../MTag/MTag.types';

export enum MMediaCarouselCarouselStyle {
  Standard = 'Standard',
  Compact = 'Compact',
}

export interface MMediaCarouselButtonIcon {
  buttonText?: string;
  icon?: string;
  iconSize?: AIconSize;
}

export interface MMediaCarouselCarouselArrow {
  transparent?: boolean;
  disabled?: boolean;
  iconSize?: string;
}

export interface MMediaCarouselScrimGradient {
  position?: 'top' | 'bottom';
  direction?: string;
  color?: string;
}

/** Image structure from AEM model (mMediaImageMulti item) */
export interface MMediaImageMultiItemImage {
  image: {
    altText?: string;
    assetPath?: string;
    damPath?: string;
    enableSmartCrop?: boolean;
    dynamic?: boolean;
    renditions?: unknown;
  };
}

/** Tag structure from AEM model (mMediaImageMulti item) */
export interface MMediaImageMultiItemTag {
  aLabel?: { text?: string | null };
  aIcon?: { size?: string; icon?: string };
  type?: string;
}

/** Single media item in mMediaImageMulti list */
export interface MMediaImageMultiItem {
  aImage?: MMediaImageMultiItemImage;
  tag?: string;
  mTag?: MMediaImageMultiItemTag;
  logo?: string;
  aLogo32?: { brand?: string };
  mButtonIcon?: { aIcon?: { size?: string; icon?: string } };
  iconButton?: string;
}

export interface MMediaCarouselProps extends React.HTMLAttributes<HTMLDivElement> {
  carouselStyle?: MMediaCarouselCarouselStyle;
  hover?: boolean;
  logo?: boolean;
  /** @deprecated Use mMediaImageMulti for AEM model compatibility */
  aImage?: AImageProps[];
  /** List of media items from AEM model - each item has aImage.image (assetPath/damPath) */
  mMediaImageMulti?: MMediaImageMultiItem[];
  aCarouselArrow?: MMediaCarouselCarouselArrow;
  aScrimGradient?: MMediaCarouselScrimGradient;
  mLogoContainer?: MLogoContainerProps;
  mButtonIcon?: MMediaCarouselButtonIcon;
  mTag?: MTagProps;
}
